var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.924,
    height: 13,
    viewBox: "0 0 19.924 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.962,9A10.712,10.712,0,0,0,2,15.5,10.712,10.712,0,0,0,11.962,22a10.707,10.707,0,0,0,9.962-6.5A10.707,10.707,0,0,0,11.962,9Zm0,10.833A4.436,4.436,0,0,1,7.434,15.5a4.436,4.436,0,0,1,4.528-4.333A4.436,4.436,0,0,1,16.49,15.5,4.436,4.436,0,0,1,11.962,19.833Zm0-6.933a2.6,2.6,0,1,0,2.717,2.6A2.662,2.662,0,0,0,11.962,12.9Z",
    transform: "translate(-2 -9)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.d61ee7a58ef3223c206a52800e472266.svg";
export { ForwardRef as ReactComponent };